(function ViatorIndex($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var total_items = 0;
		var $container  = $('.arc-marketplace-comparison-content');

		Adzuki.onload('/Viator/index/', function onload() {
			var comparison_ids  = Cookies.get('arc_comparison_ids') || '';

			$('.arc-checkbox').click(function arcCheckClicked(e) {
				e.stopPropagation();

				var comparison_ids  = Cookies.get('arc_comparison_ids') || '', // eslint-disable-line vars-on-top
				    comparison_str  = '',
				    arc_id          = $(this).data("checkbox-id"),
				    ids             = '',
				    max_items       = 5, //	arbitrary
				    i               = 0,
				    min_total_items = 0;

				if ($(this).prop('checked') === true) {
					if (comparison_ids === '') {
						comparison_str = arc_id;
						total_items    = 1;
					} else {
						ids         = comparison_ids.split('|');
						total_items = ids.length;

						if (ids.length >= max_items) {
							if (ids.length >= max_items) {
								$.alert({
									title  : 'Max Reached',
									content: 'You can only compare up to ' + max_items + ' at a time'
								});

								comparison_str = comparison_ids;
								$(this).prop('checked', false);
							}
						} else {
							total_items++;
							comparison_str = comparison_ids + '|' + arc_id;
						}
					}
				} else if (comparison_ids) {
					comparison_str = '';
					ids            = comparison_ids.split('|');
					total_items    = 0;

					for (i=0;i<=ids.length;i++) {
						if (parseInt(ids[i]) === parseInt(arc_id)) {
							ids.splice(i, 1);
						} else {
							total_items++;
						}
					}

					comparison_str = ids.join("|");
				}

				if (total_items > min_total_items) {
					Cookies.set('arc_comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showArcComparisonBox();
				} else {
					Cookies.remove('arc_comparison_ids');

					hideArcComparisonBox();
				}
			});

			$container.on('click', '.arc-comparison-remove', function comparisonRemoveOne() {
				var comparison_ids  = Cookies.get('arc_comparison_ids') || '',
				    comparison_str  = '',
				    ids             = '',
				    arc_id          = $(this).data("id"),
				    i               = 0,
				    min_total_items = 0,
				    decrementor     = 1;

				ids = comparison_ids.split('|');

				for (i=0;i<=ids.length;i++) {
					if (parseInt(ids[i]) !== parseInt(arc_id)) {
						if (comparison_str === '' && ids[i] !== arc_id && !isNaN(ids[i])) {
							comparison_str = ids[i];
						} else if (ids[i]) {
							comparison_str += '|' + ids[i];
						}
					}
				}

				$('.arc-checkbox').each(function uncheckOne() {
					if ($(this).data("checkbox-id") === arc_id) {
						$(this).prop('checked', false);
					}
				});

				total_items = parseInt(ids.length) - decrementor;

				if (total_items > min_total_items) {
					Cookies.set('arc_comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showArcComparisonBox();
				} else {
					Cookies.remove('arc_comparison_ids');
					hideArcComparisonBox();
				}
			});

			$container.on('click', '.arc-comparison-remove-all', function comparisonRemoveAll() {
				Adzuki.CustomConfirm({
					body   : 'Are you sure you want to remove all?',
					confirm: function confirm() {
						Cookies.remove('arc_comparison_ids');
						hideArcComparisonBox();

						$('.arc-checkbox').each(function uncheckAll() {
							$(this).prop('checked', false);
						});
					},
				});
			});

			$container.on('click', '.arc-comparison-view', function comparisonView() {
				var comparison_ids  = Cookies.get('arc_comparison_ids') || '';

				document.location = Adzuki.base_uri + '/Viator/compare/' + comparison_ids;
			});

			$container.on('click', '.comparison-filter', function comparisonFilterClicked() {
				if ($(this).hasClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'))) {
					$('.comparison-content').addClass('hidden');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
				} else {
					$('.comparison-content').removeClass('hidden');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
				}
			});

			if (comparison_ids !== '') {
				showArcComparisonBox();
			}
		});
	});

	// custom functions
	function showArcComparisonBox() {
		var comparison_ids = Cookies.get('arc_comparison_ids');

		$('.arc-marketplace-comparison').show();

		Adzuki.Ajax.get('/Viator/comparison/' + comparison_ids).then(function success(response) {
			$('.arc-marketplace-comparison-content').html(response);

			$('[data-toggle^="tooltip"]').tooltip();

			$('.comparison-filter').trigger('click');

			// the cached USD prices may be different due to changing exchange rates, so update the price within the search results to match the comparison HTML
			Adzuki.Ajax.get('/Viator/getUpdatedPrices/' + comparison_ids).then(function success(response) {
				$.each(response, function loop(key, value) {
					var $price = $('.item[data-id="' + value.id + '"]').find('.price');

					$price.html('USD ' + value.price_str);

					// init buckets
					Adzuki.Buckets.initAddButton($('.comparison-content .bucket-addto'));
				});
			});
		});
	}

	function hideArcComparisonBox() {
		console.log("inside the hide");
		$('.arc-marketplace-comparison').hide();
		$('.arc-marketplace-comparison-content').html('');
	}

}(jQuery, window.Adzuki || {}));
